'use strict';

function CompanyInvestigationListService($resource, config) {
  return $resource(config.apiBase + '/companies/:companyId/publications/investigations', {}, {
  });
}

angular.module('dokiv')
  .factory('CompanyInvestigationListService', ['$resource', 'config', CompanyInvestigationListService]);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/investigation-list/CompanyInvestigationListService.js
// module id = 361
// module chunks = 0